import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { Component, OnInit, Input } from '@angular/core';
import { TutorialShared } from '../../general/shared/tutorial-shared';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';

@Component({
  selector: 'app-battery',
  templateUrl: './battery.component.html',
  styleUrls: ['./battery.component.scss'],
})
export class BatteryComponent implements OnInit {
  @Input() maxCalorie: number;
  @Input() status: string;
  @Input() exerciseCalories: number = 0;

  private _dataIsReady = false;
  @Input() set dataIsReady(value: boolean) {
    this._dataIsReady = value;
    if (value) {
      this.initial();
    }
  }
  get dataIsReady(): boolean {
    return this._dataIsReady;
  }

  calorie = 0;
  chartMaxNumber = 0;
  chartNeedIndicator = false;
  chartIndicatorNumber = 0;
  public doughnutChartLabels: string[] = [];
  public demodoughnutChartData: number[][] = [[0, 0]];
  public doughnutChartType = 'doughnut';
  public chartColors: any[] = [
    {
      backgroundColor: ['#0073ff', 'rgba(0,0,0,0)'],
      borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
    },
  ];
  public options = {
    responsive: false,
    maintainAspectRatio: false,
    cutoutPercentage: 90,
  };

  constructor(
    private tutorialShared: TutorialShared,
    private planService: PlanService,
    private planShared: PlanShared,
    private calorieCalculator: CalorieCalculator
  ) {}

  ngOnInit() {}

  initial() {
    setTimeout(() => {
      this.tutorialShared.calorieChartBox =
        document.getElementById('battery-chart');
    }, 10);
    this.calculateCalorie();
  }

  public chartClicked(e: any): void {}

  public chartHovered(e: any): void {}

  calculateCalorie() {
    const foodLogs = this.planShared.selectedDietDayFoodLogs.foodLogs;
    this.calorie = this.calorieCalculator.calculateFoodLogsCalorie(foodLogs);
    if (this.status === 'diet') {
      this.chartNeedIndicator = true;
      this.chartIndicatorNumber = Math.floor(this.maxCalorie * 1.05);
      this.chartMaxNumber = Math.floor((this.chartIndicatorNumber * 10) / 9);
    } else {
      this.chartIndicatorNumber = Math.floor(this.maxCalorie * 1.05);
      this.chartMaxNumber = this.chartIndicatorNumber;
    }
    if (
      this.calorie > this.chartIndicatorNumber &&
      this.status !== 'cheatDay'
    ) {
      this.chartColors = [
        {
          backgroundColor: ['#ff2e19', 'rgba(0,0,0,0)'],
          borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
        },
      ];
    } else {
      this.chartColors = [
        {
          backgroundColor: ['#0073ff', 'rgba(0,0,0,0)'],
          borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
        },
      ];
    }
    this.demodoughnutChartData = [
      [
        this.calorie,
        this.chartMaxNumber > this.calorie
          ? this.chartMaxNumber - this.calorie
          : 0,
      ],
    ];
  }

  goToDailyFoodFact() {
    this.planService.goToDailyFoodFact();
  }
}
